import { ApiResponse } from "@portal/lib/ky";

export async function saveFileInDisk<T>(
  response: ApiResponse<T>,
  fileName?: string
) {
  return response.blob().then((url) => {
    const newUrl = URL.createObjectURL(url);
    const a = document.createElement("a");
    a.href = newUrl;
    a.download = fileName ?? "";

    document.body.appendChild(a);
    a.click();
    a.remove();
  });
}

export function downLoadFileInDisk(newUrl: string, fileName: string) {
  const a = document.createElement("a");
  a.href = newUrl;
  a.download = fileName ?? "";
  a.target = "_blank";
  a.download = "fileName";

  document.body.appendChild(a);
  a.click();
  a.remove();
}

export function getFileName<T>(fileResponse: ApiResponse<T>) {
  const disposition = fileResponse.headers.get("content-disposition");
  const result = /filename="([\S]*)"/;

  return disposition?.match(result)?.[1];
}
